var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-loading-indicator",class:{ 'c-loading-indicator--visible': _vm.visible }},[_c('div',{staticClass:"c-loading-indicator__icon"},[_vm._v("\n    Loading\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }